document.addEventListener('teeinblue-event-component-injected', function () {
  function moveElement(sourceSelector, targetSelector, position = 'after') {
    const source = document.querySelector(sourceSelector);
    const target = document.querySelector(targetSelector);

    if (!source || !target) return;

    if (position === 'before') {
      target.before(source);
    } else {
      target.after(source);
    }
  }

  moveElement('.product__info-wrapper .product-form__quantity', '.product-form__buttons .product-form__submit', 'before');
});

/*
 * Add-to-cart loading state. Teeinblue first saves the design (several
 * seconds) before the item lands in the cart and the slide cart opens;
 * show a spinner on the button and a page overlay in the meantime.
 *
 * Teeinblue's after-cart-added event is not always dispatched, so the
 * state is also cleared when the slide cart opens, when Teeinblue
 * re-enables the button itself while still saving the design (an error
 * without an error event), or after a safety timeout.
 */
(function () {
  const SAFETY_TIMEOUT_MS = 20000;
  let timer = null;
  let active = false;
  let addingToCart = false;
  let touchingButton = false;

  const overlay = () => document.getElementById('TeeCartLoading');
  const submitButton = () => document.querySelector('product-form .product-form__submit');

  const setButtonLoading = (button, loading) => {
    touchingButton = true;
    button.classList.toggle('loading', loading);
    if (loading) button.setAttribute('aria-busy', 'true');
    else button.removeAttribute('aria-busy');
    button.disabled = loading;
    const spinner = button.querySelector('.loading__spinner');
    if (spinner) spinner.classList.toggle('hidden', !loading);
    touchingButton = false;
  };

  const start = () => {
    active = true;
    addingToCart = false;
    const button = submitButton();
    if (button) setButtonLoading(button, true);
    const el = overlay();
    if (el) el.hidden = false;
    clearTimeout(timer);
    timer = setTimeout(stop, SAFETY_TIMEOUT_MS);
  };

  const stop = () => {
    if (!active) return;
    active = false;
    clearTimeout(timer);
    const button = submitButton();
    if (button) setButtonLoading(button, false);
    const el = overlay();
    if (el) el.hidden = true;
  };

  document.addEventListener('teeinblue-event-before-customization-created', start);
  // From here on Teeinblue frees the button while the cart request is
  // still running, so only the cart opening (or an event) ends the state.
  document.addEventListener('teeinblue-event-before-cart-added', () => {
    addingToCart = true;
  });
  document.addEventListener('teeinblue-event-after-cart-added', stop);
  document.addEventListener('teeinblue-event-error', stop);

  const observe = () => {
    // The slide cart opening means the item is in.
    new MutationObserver(() => {
      if (document.body.classList.contains('qsc2-drawer-opened')) stop();
    }).observe(document.body, { attributes: true, attributeFilter: ['class'] });

    // Teeinblue re-enabling the button means it is done (or gave up).
    const button = submitButton();
    if (button) {
      new MutationObserver(() => {
        if (active && !addingToCart && !touchingButton && !button.disabled) stop();
      }).observe(button, { attributes: true, attributeFilter: ['disabled'] });
    }
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observe);
  } else {
    observe();
  }
})();
